import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import useExecScripts from '../Component/useExecScripts'
import EnquiryForm from '../Component/EnquiryForm'
import EnquiryHeading from '../Component/EnquiryHeading'

function Venues() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const containerRef = useExecScripts();

	return (
		<div id="content" className="site-content">
			<div className="ast-container">
				<div id="primary" className="content-area primary">
					<main id="main" className="site-main">
						<article className="page type-page status-publish ast-article-single">
							<header className="entry-header ast-no-thumbnail ast-no-title ast-header-without-markup"></header>
							<div ref={containerRef}>
								<div className="entry-content clear" itemProp="text">


									<div data-elementor-type="wp-page" data-elementor-id="780" className="elementor elementor-780">
										<div className="elementor-element elementor-element-d6b9719 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="d6b9719" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="elementor-element elementor-element-ca5e036 elementor-widget__width-initial elementor-widget elementor-widget-elementskit-heading" data-id="ca5e036" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-heading.default">
												<div className="elementor-widget-container">
													<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">Our Venue Partners </h2><div className="ekit_heading_separetor_wraper ekit_heading_elementskit-border-divider ekit-dotted"><div className="elementskit-border-divider ekit-dotted"></div></div></div></div>				</div>
											</div>
											<div className="elementor-element elementor-element-9efa0bf e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="9efa0bf" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-36095ad e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="36095ad" data-element_type="container" data-e-type="container">
													<div className="elementor-element elementor-element-8914950 e-grid e-con-full wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="8914950" data-element_type="container" data-e-type="container">
														<div className="elementor-element elementor-element-d33b6cc ekit-equal-height-enable elementor-widget elementor-widget-elementskit-icon-box" data-id="d33b6cc" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
															<div className="elementor-widget-container">
																<div className="ekit-wid-con">        {/* link opening */}
																	{/* end link opening */}

																	<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
																		<div className="elementskit-box-header">
																			<div className="elementskit-info-box-icon ">
																				<img decoding="async" width="561" height="349" src="/assets/images/06/ecoville.jpg" className="attachment- size-" alt="" srcSet="/assets/images/06/ecoville.jpg 561w, /assets/images/06/ecoville-300x187.jpg 300w" sizes="(max-width: 561px) 100vw, 561px" />                </div>
																		</div>
																		<div className="box-body">
																			<h3 className="elementskit-info-box-title">
																				ECoville                </h3>
																			<div className="box-footer disable_hover_button">
																				<div className="btn-wraper">
																					<a className="elementskit-btn whitespace--normal" href="https://ecovillefarm.com/">
																						ENQUIRE NOW                                    </a>
																				</div>
																			</div>
																		</div>


																	</div>
																</div>				</div>
														</div>
														<div className="elementor-element elementor-element-1552aa9 ekit-equal-height-enable elementor-widget elementor-widget-elementskit-icon-box" data-id="1552aa9" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
															<div className="elementor-widget-container">
																<div className="ekit-wid-con">        {/* link opening */}
																	{/* end link opening */}

																	<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
																		<div className="elementskit-box-header">
																			<div className="elementskit-info-box-icon ">
																				<img decoding="async" width="371" height="400" src="/assets/images/10/ledgamezone.jpg" className="attachment- size-" alt="LED family entertainment centre, West Pune – birthday parties and events" />                </div>
																		</div>
																		<div className="box-body">
																			<h3 className="elementskit-info-box-title">
																				LED – Live Entertainment Destination                </h3>
																			<div className="box-footer disable_hover_button">
																				<div className="btn-wraper">
																					<a className="elementskit-btn whitespace--normal" href="https://ledgamezone.com/" target="_blank" rel="noopener noreferrer">
																							ENQUIRE NOW                                    </a>
																				</div>
																			</div>
																		</div>


																	</div>
																</div>				</div>
														</div>
														<div className="elementor-element elementor-element-a46e48c ekit-equal-height-enable elementor-widget elementor-widget-elementskit-icon-box" data-id="a46e48c" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
															<div className="elementor-widget-container">
																<div className="ekit-wid-con">        {/* link opening */}
																	{/* end link opening */}

																	<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
																		<div className="elementskit-box-header">
																			<div className="elementskit-info-box-icon ">
																				<img loading="lazy" decoding="async" width="399" height="254" src="/assets/images/06/kaizen.jpg" className="attachment- size-" alt="" srcSet="/assets/images/06/kaizen.jpg 399w, /assets/images/06/kaizen-300x191.jpg 300w" sizes="(max-width: 399px) 100vw, 399px" />                </div>
																		</div>
																		<div className="box-body">
																			<h3 className="elementskit-info-box-title">
																				Kaizen Early Years                </h3>
																			<div className="box-footer disable_hover_button">
																				<div className="btn-wraper">
																					<a className="elementskit-btn whitespace--normal" href="https://kaizenearlyyears.com/">
																						ENQUIRE NOW                                    </a>
																				</div>
																			</div>
																		</div>


																	</div>
																</div>				</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-5cff919c e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="5cff919c" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="elementor-element elementor-element-4e9665ff e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="4e9665ff" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
												<div className="e-con-inner">
													<div className="elementor-element elementor-element-37b5d7a7 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="37b5d7a7" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
																												<EnquiryHeading widgetElementId="31d6c3f9" />

																												<EnquiryForm widgetElementId="ee5a5b3" />

													</div>
												</div>
											</div>
										</div>
									</div>



								</div>{/* .entry-content</div> */}
							</div>
						</article>
					</main>
				</div>
			</div>
		</div>
	)
}

export default Venues

